import { Assets } from '@/constants/assets';
import { ExternalSystemEnum } from '@/generated/graphql';

export const TimeOffDuration = {
	AllDay: 'all_day',
	ExactTime: 'exact_time',
} as const;

export const ALL_DAY_VALUE = -1;

export const DEFAULT_TIME_AMOUNT = 3600;

export const SECONDS_IN_A_DAY = 60 * 60 * 24;

export const TimeOffSystemType = {
	Vacation: 'vacation',
	MedicalLeave: 'medical_leave',
	ParentalLeave: 'parental_leave',
	StudyLeave: 'study_leave',
	ExtraAvailability: 'extra_availability',
	Other: 'other',
} as const;

export const EXTERNAL_SYSTEM_ICON: Record<ExternalSystemEnum, string> = {
	[ExternalSystemEnum.BambooHr]: Assets.BAMBOO_HR_LOGO,
	[ExternalSystemEnum.GoogleCalendar]: Assets.GOOGLE_CALENDAR_LOGO,
};

export const EXTERNAL_SYSTEM_TOOLTIP: Record<ExternalSystemEnum, string> = {
	[ExternalSystemEnum.BambooHr]: 'time-off-type__bamboo-hr-tooltip',
	[ExternalSystemEnum.GoogleCalendar]:
		'time-off-type__google-calendar-tooltip',
};
